export default __webpack_public_path__ + "static/media/1553.7c06beff.png";